/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const WeightUnit = {
    Lb: 'LB',
    Kg: 'KG'
} as const;
export type WeightUnit = typeof WeightUnit[keyof typeof WeightUnit];

